import { FilterBar2, FilterBar2ListItem, FilterBar2SelectItem } from '.';
import { FILTER_CONDITIONS } from '@bringg/types';
import { Translations } from './filter-bar-2';

/**
 * Filter object from query can have values that should be array of numbers but instead the value in the object is number
 * When user select 1 item from multiselect filter
 */
export function convertFilterObjectValuesToRelevantValueTypes(
	list: FilterBar2ListItem[],
	filterObjectFromQuery: Record<string, unknown>
): Record<string, unknown> {
	const filterObjectWithRightTypes = { ...filterObjectFromQuery };

	const arrayKeys = list
		.filter(
			item => (item as FilterBar2SelectItem).multiselect === true || item.type === FilterBar2.TYPES.TREE_SELECT
		)
		.map(item => item.name);

	arrayKeys.forEach(itemKey => {
		if (filterObjectWithRightTypes[itemKey] !== undefined && !Array.isArray(filterObjectWithRightTypes[itemKey])) {
			filterObjectWithRightTypes[itemKey] = [filterObjectWithRightTypes[itemKey]];
		}
	});

	return filterObjectWithRightTypes;
}

export const getDefaultFilterBarTranslations = (t: (key: string) => string): Translations => ({
	moreFilters: t('FILTER_BAR.ADD_FILTERS'),
	reset: t('FILTER_BAR.RESET'),
	done: t('FILTER_BAR.DONE'),
	cancel: t('FILTER_BAR.CANCEL'),
	search: t('FILTER_BAR.SEARCH'),
	all: t('FILTER_BAR.ALL'),
	selectAll: t('FILTER_BAR.SELECT_ALL'),
	specifiedPeriod: t('FILTER_BAR.SPECIFIED_PERIOD'),
	preset: t('FILTER_BAR.PRESET'),
	teams: t('FILTER_BAR.PARENT_TEAMS'),
	subTeams: t('FILTER_BAR.TEAMS'),
	conditionFilter: {
		operatorSelectPlaceholder: t('FILTER_BAR.CONDITION_FILTER.PLACEHOLDER'),
		options: {
			[FILTER_CONDITIONS.EQUALS]: t('FILTER_BAR.CONDITION_FILTER.EQUALS'),
			[FILTER_CONDITIONS.NOT_EQUALS]: t('FILTER_BAR.CONDITION_FILTER.NOT_EQUALS'),
			[FILTER_CONDITIONS.IS_EMPTY]: t('FILTER_BAR.CONDITION_FILTER.IS_EMPTY'),
			[FILTER_CONDITIONS.IS_NOT_EMPTY]: t('FILTER_BAR.CONDITION_FILTER.IS_NOT_EMPTY'),
			[FILTER_CONDITIONS.GREATER_THAN]: '>',
			[FILTER_CONDITIONS.GREATER_THAN_OR_EQUALS]: '≥',
			[FILTER_CONDITIONS.LESS_THAN]: '<',
			[FILTER_CONDITIONS.LESS_THAN_OR_EQUALS]: '≤'
		}
	}
});

export const filterOption = (input, { label }) => label.toLowerCase().indexOf(input.toLowerCase().trim()) >= 0;
